import { type PaymentSettings } from 'digital-settings/common/entities'
import { type PartialDeep } from 'type-fest'
import { httpClientVendasCoreBff } from 'vendas-core/shared/services'

import { httpWithChallenge } from '~/domains/platform/infra/http/http-with-challenge'

export function patchPaymentSettingsWithChallenge(paymentProfileId: string, data: PartialDeep<PaymentSettings>) {
  return httpWithChallenge({
    config: {
      url: `/v1/payment-profile/${paymentProfileId}/payments-settings`,
      method: 'PATCH',
      data
    },
    client: httpClientVendasCoreBff
  })
}
